import React from 'react'
import styled from 'styled-components'
import Fade from 'react-reveal/Fade'
import { BrowserRouter, Route, Link } from "react-router-dom";

const Footer = () => {

    return (
        <>
		{/* style={{ backgroundImage: `url(${learn})` }} */}
         <Wrap >
			{/* <img className='img' src={learn} /> */}
         <Fade bottom>
            <ItemText>
                     <h1>Unlock your full potential at CodeZen.</h1>
				</ItemText>
			</Fade>
            <Buttons>
				<Fade bottom>
					<ButtonGroup>
						<LeftButton>
							
						<Link to="/contact" className='link'>Join Now</Link>
						</LeftButton>
					
					</ButtonGroup>
				</Fade>
			</Buttons>
         </Wrap>
         
        </>
    );

}

export default Footer;


const Wrap = styled.div `
    color:white;
    min-height:50vh;
	background-size: cover; /* set size to cover */
	background-position: center; /* center the image */
	background-repeat: no-repeat; /* dont repeat the background */

	display: flex;
	flex-direction: column; /* switch to vertical */
	justify-content: center; /* horizontal alignment */
	align-items: center; /* vertical alignment */

	@media (max-width : 768px){
		flex-direction: column;
	}
`

const ItemText = styled.div `
	padding-top: 15vh;
	text-align: center;
`

const ButtonGroup = styled.div `
	display: flex;
	margin-bottom: 30px;

	@media (max-width: 768px){
		flex-direction: column;
	}
`

const LeftButton = styled.div `
	background-color: green;
	height: 40px;
	width: 256px;
	color: white;
	display: flex;
	justify-content: center;
	align-items: center;
	border-radius: 100px;
	opacity: 0.85;
	text-transform: uppercase;
	font-size: 12px;
	font-weight: 600;
	cursor: pointer;
	letter-spacing: 1px;
	margin: 8px;
`

const Buttons = styled.div `
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
`